import type { ApiError } from './apiError';

/** Ein Server-Code wie `booking_not_found`; ky setzt ohne Problem-Body seine englische Meldung samt URL. */
const CODE = /^[a-z][a-z0-9]*(?:[_.][a-z0-9]+)+$/;

/**
 * Deutscher Satz zu einem Fehler. `detail` bleibt draußen: der Server schreibt dort meist
 * Entwicklertext auf Englisch (`BaseController.ToProblem`). Bekannte Codes bekommen ihren Satz,
 * Codes mit bewusst deutschem `detail` (`detailFor`) ihren Servertext, sonst steht der allgemeine
 * Satz da – mit Code, wenn es einer ist, sonst mit Status.
 */
export function problemText(
  problem: ApiError | null,
  fallback: string,
  { known = {}, detailFor = [] }: { known?: Record<string, string>; detailFor?: string[] } = {},
): string {
  if (!problem) return fallback;
  if (problem.detail && detailFor.includes(problem.title)) return problem.detail;
  const text = known[problem.title];
  if (text) return `${text} (${problem.title})`;
  if (problem.status === 0) return `${fallback} Keine Verbindung.`;
  return CODE.test(problem.title)
    ? `${fallback} (Code ${problem.title})`
    : `${fallback} (Status ${problem.status})`;
}
